<template>
    <div class="create-goods">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/deviceStandard' }">客户设备状态</el-breadcrumb-item>
            <el-breadcrumb-item>充值</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem; background-color: white">
            <el-form ref="form" :rules="rules" :model="form" label-width="180px">
                <el-form-item label="所属企业" prop="epId" >
                    <el-select v-model="form.epId" placeholder="请选择">
                        <el-option
                                v-for="item in enterprises"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备名称" prop="name">
                    <el-col :span="8">
                        <el-select v-model="form.name" placeholder="请选择" @change="onNameSelect">
                            <el-option
                                    v-for="item in deviceNames"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.name">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-form-item>
                <el-form-item label="设备型号" prop="deviceTypeId" v-if="deviceTypes.length > 0">
                    <el-select v-model="form.deviceTypeId" placeholder="请选择">
                        <el-option
                                v-for="item in deviceTypes"
                                :key="item.id"
                                :label="item.model"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="剩余充值次数" v-if="reduceRechargeTimes >= 0">
                    <el-col :span="4">{{reduceRechargeTimes}}</el-col>
                </el-form-item>
                <el-form-item label="充值次数" prop="amount">
                    <el-col :span="4">
                        <el-input type="number" v-model="form.amount"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">立即创建</el-button>
                    <el-button @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import deviceApi from "../../api/device";
    import enterpriseApi from "../../api/enterprise";
    import deviceTypeApi from "../../api/deviceType";
    import deviceStandardApi from "../../api/deviceStandard";
    export default {
        data: function () {
            return {
                form: {
                    useableCount: 0,
                    shareState: 1,
                    anymousState: 0
                },
                reduceRechargeTimes: -1,
                loading: false,
                types:[
                    {
                        name: "个人用户",
                        value: 1
                    },
                    {
                        name: "企业用户",
                        value: 0
                    }
                ],
                enterprises: [],
                deviceNames: [],
                deviceTypes: [],
                rules: {
                    epId: [{required: true, message: "请选择所属企业", trigger: "blur"}],
                    deviceTypeId: [{required: true, message: "请选择设备型号", trigger: "blur"}],
                    amount: [{required: true, message: "请输入产品序列号", trigger: "blur"}],
                    name: [{required: true, message: "请输入设备名称", trigger: "blur"}],
                },
            }
        },
        watch: {
          form: {
              handler(val, oldVal) {
                  if(val.epId && val.deviceTypeId) {
                      deviceStandardApi.findByEpAndType(val.epId, val.deviceTypeId).then(res => {
                          console.log(res)
                          if(res) {
                              this.reduceRechargeTimes = res.useableCount;
                          } else {
                              this.reduceRechargeTimes = 0;
                          }
                      });
                  }
              },
              deep: true
          }
        },
        mounted: function() {
            this.loadEnterprises();
            this.loadDeviceNames();
        },
        methods: {
            onSubmit: function () {
                this.$refs["form"].validate(valid => {
                    if(!valid) return;
                    const loading = this.$loading({
                        lock: true,
                        text: '充值中',
                        spinner: 'el-icon-loading',
                    });
                    deviceStandardApi.recharge(this.form.epId, this.form.deviceTypeId, this.form.amount).then(res => {
                        loading.close();
                        this.$message({
                            type: 'success',
                            message: '充值成功!'
                        });
                        this.$router.back();
                    }).catch(() => loading.close());

                })

            },
            loadEnterprises: function () {
                enterpriseApi.getAll2().then(res => {
                    this.enterprises = res;

                })
            },
            loadDeviceNames: function() {
                deviceTypeApi.listNames().then(res => {
                    this.deviceNames = res;
                    deviceTypeApi.findByName()
                });
            },
            onNameSelect: function() {
                this.form = {...this.form, deviceTypeId: ""}
                deviceTypeApi.findByName(this.form.name).then(res => this.deviceTypes = res);
            },
            onEpChange: function () {
                console.log(this.form.epId)
                const epId = this.form.epId;
                if(epId) {
                    this.form = {
                        ...this.form,
                        standardId: null
                    }
                    deviceTypeApi.getByEpId(epId).then(res => this.standards = res);
                }
            }
        }
    }
</script>
<style lang="less">
    .standards {
        .add-standard {
            color: #1c6ca1;
            cursor: pointer;
        }
    }
</style>
